import { render, staticRenderFns } from "./darkLayout.vue?vue&type=template&id=31005936"
import script from "./darkLayout.vue?vue&type=script&lang=ts"
export * from "./darkLayout.vue?vue&type=script&lang=ts"
import style0 from "./darkLayout.vue?vue&type=style&index=0&id=31005936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports